import {MessageCircle,MoreHorizontal} from 'lucide-react';
import type {PDFStructure} from '@reados/contracts';
import {outlinePageRangeText} from '../pdf-outline';
import {ToolbarMenu} from './Pane';
import '../pdf-outline-attachments.css';

export function PdfOutlineRows({structure,page,onNavigate,onAdd}:{structure:PDFStructure;page:number;onNavigate:(page:number)=>void;onAdd?:(entryId:string)=>void}){
 return <>{structure.outline.map(entry=><div className={`pdf-outline-row${entry.pageNumber===page?' active':''}`} key={entry.id} data-outline-id={entry.id}>
  <button type="button" className={`outline-link ${entry.pageNumber===page?'active':''}`} style={{paddingLeft:Math.min(entry.level-1,5)*12+8}} onClick={()=>onNavigate(entry.pageNumber)}><span>{entry.title}</span><small>{outlinePageRangeText(structure,entry.id)}</small></button>
  {onAdd&&<ToolbarMenu className="pdf-outline-actions" label={`目录“${entry.title}”的操作`} icon={<MoreHorizontal size={16}/>}>
   <button type="button" data-menu-action onClick={()=>onAdd(entry.id)}><MessageCircle size={17}/>添加到对话</button>
  </ToolbarMenu>}
 </div>)}</>;
}
